import Model, { attr, hasMany } from '@ember-data/model';
import { validator, buildValidations } from '@eflexsystems/ember-tracked-validations';
import { tracked } from '@glimmer/tracking';
import { arrayAttr } from 'eflex/decorators';
import { getOwner } from '@ember/application';
import moment from 'moment-timezone';

@buildValidations({
  name: [
    validator('inline', {
      validate(name, options, workInstructionFolder) {
        const intl = getOwner(workInstructionFolder).lookup('service:intl');
        if (name === intl.t('none')) {
          return intl.t('workInstructions.folderNameInvalid');
        }

        return true;
      },
    }),
  ],
})
class WorkInstructionFolder extends Model {
  @attr('string') name;
  @attr('date') createdAt;
  @attr('date') updatedAt;

  @hasMany('work-instruction', { async: false, inverse: 'folder' }) workInstructions;

  @arrayAttr wieEditorTags;
  @arrayAttr wieApproverTags;
  @arrayAttr wieDeployerTags;

  @tracked isSelected = false;

  get isFolder() {
    return true;
  }

  get updatedAtFormatted() {
    return moment(this.updatedAt).format('M/DD/YY h:mma').slice(0, -1);
  }
}

export default WorkInstructionFolder;
